












import { Vue, Prop, Component } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { UserSettings as IUserSettings } from "@/api-v2/notification/models/user-settings";
import {
  translateNotificationType,
  NotificationSettingsTypes
} from "@/services/notifications";

@Component({
  components: { CBlock }
})
export default class UserNotificationSettings extends Vue {
  @Prop() settings?: IUserSettings;
  @Prop() type!: NotificationSettingsTypes;

  get form() {
    return this.settings;
  }

  set form(value) {
    this.$emit("update:settings", value);
  }

  get label() {
    return translateNotificationType(this.type);
  }
}
